<template>
    <div class="user-bar">
        <transition name="fade">
            <div v-if="isSignedIn">
                <p
                  class="user-bar__text"
                >
                  Witaj {{ email }}!
                  <a
                    href=""
                    @click.prevent="logout"
                  >Wyloguj się</a>
                </p>
            </div>
            <div v-else>
                <p class="user-bar__text"><router-link to="login">Zaloguj się</router-link></p>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
  computed: {
    isSignedIn() {
      return this.$store.state.auth.isSignedIn;
    },

    email() {
      return this.$store.state.auth.email;
    },
  },

  methods: {
    logout() {
      this.$emit('logout');
    },
  },
};
</script>

<style lang="scss">
    .user-bar {
        &__text {
            margin: 0;
        }
    }
</style>
